import { CalculateFestivalCo2 } from '@/domain/impact-calculate-festival/entities/calculate-festival-co2.entity';
import { ProjectFestival } from '@/domain/project-festival/entities/project-festival.entity';
import {
  selectCurrentProjectFestival,
  selectProjectFestivalById,
} from '@/domain/project-festival/project-festival.selectors';
import { RootState } from '@/domain/store';

export function computeKgCo2ByParticipantFestival(
  state: RootState,
  calculateCo2: CalculateFestivalCo2,
  projectId: number,
): number {
  const project = getProject(state, projectId);
  return computeKgCo2ByParticipantFestivalProject(project, calculateCo2);
}

export function computeKgCo2ByParticipantFestivalProject(
  project: ProjectFestival | null,
  calculateCo2: CalculateFestivalCo2,
): number {
  if (!project) {
    return -1;
  }
  const scoreKgeCO2 = calculateCo2.scoreKgeCO2;
  const avgCapacity = project.avgCapacity;
  const kgeCO2ByParticipant = scoreKgeCO2 / (avgCapacity || 1);
  return kgeCO2ByParticipant;
}

function getProject(
  state: RootState,
  projectId: number,
): ProjectFestival | null {
  const project = selectProjectFestivalById(projectId)(state);
  if (project) {
    return project;
  }
  const currentProject = selectCurrentProjectFestival(state);
  if (currentProject && currentProject?.id === projectId) {
    return currentProject;
  }
  return null;
}
